module.exports = __webpack_public_path__ + "static/template_options_month_columns-64aed58df591c36ef7d3f8009b300d4a.png";